interface DefaultFormRegistrationMethod {
    formRegistrationMethod: string;
    setRegistrationMethod: (method: 'manual' | 'barcode') => void;
}

const createDefaultFormRegistrationMethodSlice = (set: any) => {
    return {
        formRegistrationMethod: 'manual',
        setRegistrationMethod: (method: 'manual' | 'barcode') => {
            set(() => ({
                formRegistrationMethod: method,
            }));
        },
    };
};

export { createDefaultFormRegistrationMethodSlice };
export type { DefaultFormRegistrationMethod };
